import { useTranslation } from "react-i18next";

export default function Testimonials() {
  const { t } = useTranslation("wie-zijn-wij");
  const items = t("testimonials.items", { returnObjects: true }) as Array<{
    name: string;
    area: string;
    text: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("testimonials.h2")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-xl p-6 md:p-8 border border-brand-border hover:border-brand-yellow transition-colors"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-brand-yellow text-sm w-4 h-4 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="font-geist text-sm md:text-base text-brand-text/80 leading-relaxed mb-5 md:mb-6">
                “{item.text}”
              </p>
              <div>
                <p className="font-geist font-bold text-sm text-brand-text">
                  {item.name}
                </p>
                <p className="font-geist text-xs text-brand-text/50">
                  {item.area}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}